import {valueSchema, validationSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'number_of_workers'

export const dataPointDefinition = {
  retracedId: 'number_of_workers',
  name: 'Total number of workers:',
  description:
    'Workers are persons working on/with the facility\'s product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them. Facilities include those involved in production of goods, and also those involved in operations related to the product, e.g. distribution. Examples of "workers" are cutters, sewers, QC, packers, etc. (all workers who contribute to produce the product), boiler workers, mechanics (machine repair persons), and workers who load product onto trucks.\r\r\n\r\r\nNumber of workers is not mutually exclusive. Meaning, a worker can be included in multiple worker number counts. For example, a worker who is both "Full-Time" and a "Migrant", should be included in BOTH types of worker number counts.',
  meta: {
    rangeValidation: true,
    optionalRange: true,
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-ed-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1040,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = async (data, {validatorFn}) => {
  try {
    validate({value: data, schema: valueSchema})

    if (!validatorFn) {
      return data
    }

    if (validatorFn && typeof validatorFn !== 'function') {
      throw new Error(`expect range limits function to be a function, got ${typeof validatorFn}`)
    }

    const {value} = data

    const rangeValues = await validatorFn()
    validate({value: rangeValues, schema: validationSchema})

    const {min, max} = rangeValues
    if (min && value < min) {
      throw new Error('data mismatch, value is less than minimum allowed value')
    }

    if (max && value > max) {
      throw new Error('data mismatch, value is greater than maximum allowed value')
    }

    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
